import { useCallback } from "react";
import { makeVar, ReactiveVar, useReactiveVar } from "@apollo/client";

// True after the user closes the setup meeting banner on the Ollie dashboard. The value lives only
// in memory, so the banner shows again after a page reload. Logout clears it, so the banner also
// shows again after a new sign in.
const setupMeetingBannerDismissedInitialValue = false;

export const setupMeetingBannerDismissedVar: ReactiveVar<boolean> = makeVar<boolean>(
	setupMeetingBannerDismissedInitialValue
);

export const clearSetupMeetingBannerDismissed = () => {
	setupMeetingBannerDismissedVar(setupMeetingBannerDismissedInitialValue);
};

export const useSetupMeetingBannerDismissed = () => {
	const isSetupMeetingBannerDismissed = useReactiveVar(setupMeetingBannerDismissedVar);

	const dismissSetupMeetingBanner = useCallback(() => {
		setupMeetingBannerDismissedVar(true);
	}, []);

	return {
		isSetupMeetingBannerDismissed,
		dismissSetupMeetingBanner
	};
};
